import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import hotstar from "../Assets/image 47.svg";
import line from "../Assets/Rectangle 40191.svg";
import ott1 from "../Assets/image 47.svg";
import arrow from "../Assets/Back.svg";
import tick from "../Assets/yes-alt-svgrepo-com 1.svg";
import { Modal, ModalBody } from "reactstrap";
import { useAuth } from "../authContext";

function OttApp() {
  const { isLoggedIn } = useAuth();
  const [modal, setModal] = useState(false);
  return (
    <div className="homepage">
      <Navbar />
      <br />
      <br />
      <div className="app-section">
        <div className="app">
          <h3>
            <span>Home &nbsp; Digital </span> &gt; Hotstar, App{" "}
          </h3>
          <div className="product">
            <div>
              <img alt="" src={hotstar} />
            </div>
            <div className="prd-desc">
              <h2>Advertising in HotStar, App</h2>
              <br />
              <p>
                Hotstar is an online video streaming platform owned by Novi
                Digital Entertainment Private Limited. Hotstar currently offers
                over 100,000 hours of TV content, it has huge market covering
                over 150 Million users. Brands can place digital advertisements
                like banner ads and roadblock, which is quite effective.
              </p>
            </div>
          </div>

          <br />
          <h4>Key Insights</h4>
          <br />

          <div className="keyinsi">
            <div className="key">
              <p>
                <span>Category :</span> Entertainment
              </p>
            </div>
            <div className="key">
              <p>
                <span>Language :</span> English
              </p>
            </div>
            <div className="key">
              <p>
                <span>Pricing Range :</span> Low to High
              </p>
            </div>
            <div className="key">
              <p>
                <span>Reach / Impression :</span> 150 Millions
              </p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />

      <div>
        <div className="trendingOffer-section-heading">
          <img alt="" src={line} />
          <h1>Advertising Options in HotStar, App</h1>
        </div>
        <br />
        <br />
        <div className="OTT-cards-section">
          <div className="OTT-cards">
            <div className="option-cards">
              <img src={ott1} className="w-full" alt="ott" />
              <div className="OTT-INFO">
                <h3>Spotlight Frames</h3>
                <p className="ott-p">
                  <img alt="" src={tick} /> Video & Display Ads
                </p>
                <p className="ott-p">
                  <img alt="" src={tick} /> Video & Display Ads
                </p>
                <p className="ott-p">
                  <img alt="" src={tick} /> Video & Display Ads
                </p>
              </div>
              {isLoggedIn ? (
                <button className="w-full" onClick={() => setModal(true)}>
                  Add to Plan <img alt="" className="logarrow" src={arrow} />
                </button>
              ) : (
                <button className="w-full">
                  Login to View Price <img alt="" className="logarrow" src={arrow} />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="ifo">
          <p>
            Hotstar is a digital video streaming platform with a vast array of
            over 100,000 hours of television content and an extensive user base
            of over 150 million people. Hotstar ads or Hotstar Advertisements
            provide high-impact marketing tools that can help increase
            visibility and promote brand awareness.
          </p>
        </div>

        <div className="ifo">
          <h2>How To Do Hotstar Advertisement With Excellent Publicity</h2>
          <p>
            Ads in Hotstar is a top streaming service in India, and with its
            growing user base, it is becoming an excellent platform for
            advertisers to reach their target audience. With 50 + channels, 1300
            TV shows, and 65000 hours of regional programming, brands can
            leverage digital advertising with Hotstar to publish ads that will
            reach millions of targeted viewers.
          </p>
        </div>
        <div className="ifo">
          <h2>What Are The Rates for In-App Advertising On Hotstar</h2>
          <p>
            Hotstar ads has emerged as the frontrunner among OTT platforms,
            commanding a staggering 75% of the market share and a viewership in
            the millions. With its ability to cater to diverse audiences,
            Hotstar has become a preferred choice for brands across various
            domains, such as telecom, e-commerce, food and more.
          </p>
          <p>
            For digital advertising for businesses on Hotstar Excellent
            Publicity provides an exhaustive range of cost models to choose
            from, including CPM, CPL, CPC, and CPA, ensuring that brands can
            select the most suitable option. With Hotstar advertising cost
            starting at a minimum of INR 2,50,000, brands can leverage the
            platform to drive their marketing campaigns to success. Contact us
            to know how we can get you the best rates.
          </p>
        </div>
        <div className="ifo">
          <h2>Benefits of Choosing Hotstar for In-App advertising</h2>
          <p>
            Ads in Hotstar is a top streaming service in India, and with its
            growing user base, it is becoming an excellent platform for
            advertisers to reach their target audience. With 50 + channels, 1300
            TV shows, and 65000 hours of regional programming, brands can
            leverage digital advertising with Hotstar to publish ads that will
            reach millions of targeted viewers.
          </p>
        </div>
        <br />
        <br />
        <div className="work-section">
          <div className="work">
            <h1>How Does Hotstar Advertisement Work</h1>
            <br />

            <h2>Let us know your requirements</h2>
            <p>
              Share your advertising needs and preferences with team Excellent
              Publicity to begin a campaign.
            </p>
            <br />

            <h2>Partner with us for digital success</h2>
            <p>
              Our team will then help you in selecting the perfect audience, ad
              format, and other important factors.
            </p>
            <br />

            <h2>Affordable rates, top-notch services</h2>
            <p>
              We offer unbeatable rates for Hotstar and other advertising
              platforms, with prices varying based on the chosen app.
            </p>
            <br />

            <h2>Provide striking visuals</h2>
            <p>
              Submit an eye-catching visual in CDR format for images or MOV
              format for videos to showcase your brand on-screen.
            </p>
            <br />

            <h2>Get your brand on-screen</h2>
            <p>
              We’ll launch your brand on the Hotstar screen and you’ll soon
              start receiving the projected responses.
            </p>
            <br />

            <h2>Every Bit Monitors</h2>
            <p>
              Stay updated on your brand’s progress with highly detailed ad
              campaign reports from our team.
            </p>
          </div>
        </div>

        <div className="howtostart">
          <h1>How to Get Started?</h1>
          <br />
          <br />
          <br />
          <br />

          <div className="steps">
            <div className="step">
              <div className="count">
                <h3>1</h3>
              </div>
              <h1>Share your requirements</h1>
              <p>
                Approach our efficient planners and executors and share your
                requirements for a campaign.
              </p>
            </div>
            <div className="step">
              <div className="count">
                <h3>2</h3>
              </div>
              <h1>Plan the campaign with us</h1>
              <p>
                We will assist you in terms of choosing the target audience,
                right ad format, audience reach, and campaign duration to have a
                successful campaign on the digital platform.
              </p>
            </div>
            <div className="step">
              <div className="count">
                <h3>3</h3>
              </div>
              <h1>Receive the best quotes</h1>
              <p>
                We provide lowest assured rates with best services for Digital
                Marketing across various Apps. The advertising rates differ
                depending on the App that is selected
              </p>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />

          <div className="steps">
            <div className="step">
              <div className="count">
                <h3>4</h3>
              </div>
              <h1>Provide Creative</h1>
              <p>
                Provide us with an attractive creative to showcase your brand
                on-screen. The acceptable format of creative in cinema
                advertising is a CDR file for image creative and a MOV File for
                Video Creatives.
              </p>
            </div>
            <div className="step">
              <div className="count">
                <h3>5</h3>
              </div>
              <h1>Go Live</h1>
              <p>
                See your brand hit on-screen within a bare minimum timeframe and
                achieve a grandstanding response.
              </p>
            </div>
            <div className="step">
              <div className="count">
                <h3>6</h3>
              </div>
              <h1>Receive Campaign Reports</h1>
              <p>
                Campaign Reports will be shared with you on regular intervals,
                to keep you updated with the campaign Performance
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mediaexp-section">
        <div className="mediaexp">
          <h1>
            Reach out to our Media Expert for more details about
            <br /> Digital Advertising
          </h1>
          <button>Contact us </button>
        </div>
      </div>

      <br />

      <Footer />

      <Modal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        className="modal-dialog-centered"
        style={{ maxWidth: "741px", maxHeight: "612px" }}
      >
        <ModalBody className="d-flex flex-column justify-content-center align-items-center">
          <h1 className="mt-4">HotStar,App(Mid Roll Ad CPM)</h1>{" "}
          <div className="w-100 border-bottom"></div>
          <hr />
          <div
            className="d-flex justify-content-center align-items-center gap-1 ms-4 "
            style={{ width: "514px", height: "67px" }}
          >
            <div className="w-50 h-100">
              <p>
                <b>Banner Type *</b> <span>Reset</span>
              </p>
              <p>
                <b>Up To 10 Secounds</b>
              </p>
            </div>
            <div className="w-50 h-100">
              <p>
                <b>#impression(s)*</b>
              </p>
              <p>
                <b>84000</b>
              </p>
            </div>
          </div>
          <div className="border-bottom w-100"></div>
          <div
            className="d-flex justify-content-evenly align-items-center mt-3"
            style={{ width: "383px" }}
          >
            <span className="min-w-25">Rate</span>
            <span>:</span>
            <span>Rs 0.22</span>
          </div>
          <div
            className="d-flex justify-content-evenly align-items-center"
            style={{ width: "383px" }}
          >
            <span className="min-w-25">Sub Total</span>
            <span>:</span>
            <span>Rs 180600.00</span>
          </div>
          <div
            className="d-flex justify-content-evenly align-items-center"
            style={{ width: "383px" }}
          >
            <span className="min-w-25">Min Billing</span>
            <span>:</span>
            <span>Rs 250600.00</span>
          </div>
          <div
            className="d-flex justify-content-evenly align-items-center  border-bottom"
            style={{ width: "383px" }}
          >
            <span className="min-w-25">GST (18%)</span>
            <span>:</span>
            <span>Rs 32508.00</span>
          </div>
          <div
            className="d-flex justify-content-evenly align-items-center"
            style={{ width: "383px" }}
          >
            <span className="min-w-25">Grand Total</span>
            <span>:</span>
            <span>Rs 213108.00</span>
          </div>
          <hr />
          <div className="d-flex justify-content-evenly align-items-center w-50 gap-3 mb-5">
            <button className="btn btn-dark">
              Add To Plan <img alt="" className="logarrow" src={arrow} />
            </button>
            <button className="btn btn-dark">Cancel</button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default OttApp;
